import Hero from "../components/Hero";
import FeatureStrip from "../components/FeatureStrip";
import TealWaveCTA from "../components/TealWaveCTA";
import ForEveryone from "../components/ForEveryone";
import MeetSophie from "../components/MeetSophie";
import OurStory from "../components/OurStory";
import SupportSympTrack from "../components/SupportSympTrack";
import Contact from "../components/Contact";

export default function HomePage() {
  return (
    <main id="main">
      <Hero />
      <FeatureStrip />
      <TealWaveCTA />
      <ForEveryone />
      <MeetSophie />
      <OurStory />
      <SupportSympTrack />
      <Contact />
    </main>
  );
}
